import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Reveal } from './Reveal';
import { WaitlistCTA } from '../WaitlistCTA';
export function SectionTwo() {
  return <section className="relative flex min-h-screen flex-col supports-[height:100svh]:min-h-[100svh]" data-id="element-2109">
      <div className="relative flex flex-1 flex-col justify-center gap-10 px-5 pt-24 sm:flex-row sm:items-center sm:justify-between sm:gap-8 sm:px-8 sm:pt-0 md:px-12" data-id="element-2110">
        <h2 className="max-w-sm text-4xl font-title font-medium leading-[1.05] tracking-tight text-white drop-shadow-lg sm:text-5xl md:text-6xl" data-id="element-2111">
          <Reveal delay={100} data-id="element-2112">Architect</Reveal>
          <Reveal delay={220} data-id="element-2113">
            <span className="italic font-light" data-id="element-2114">anything.</span>
          </Reveal>
        </h2>
      </div>

      <div className="relative flex flex-col gap-8 px-5 pb-16 sm:px-8 md:px-12 md:pb-20" data-id="element-2115">
        <Reveal delay={460} data-id="element-2116">
          <p className="max-w-xs text-sm leading-relaxed text-white/85 drop-shadow-md" data-id="element-2117">
            Describe the outcome you want and Giga designs the workflow to get
            there—wiring up the steps, tools, and logic. From idea to working
            system, it builds whatever you can imagine.
          </p>
        </Reveal>
        <Reveal delay={580} data-id="element-2118">
          <WaitlistCTA className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#EA580C] px-8 py-3 text-sm font-semibold text-white shadow-lg shadow-[#EA580C]/20 transition-all duration-300 hover:bg-[#d24e09] hover:scale-105" data-id="element-2119">
            Get started for free
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5" data-id="element-2120" />
          </WaitlistCTA>
        </Reveal>
      </div>
    </section>;
}